// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__28gKj","ranges":"BmiRanges_ranges__1JeW9"};